import styled from 'styled-components';

export const CenteredPercents = styled.div`
  display: flex;
  gap: 10px;
  overflow: visible !important;
`;
